import React, { useState, useEffect } from 'react';
import Wrapper from '../../components/Wrapper';
import axiosInstance from '../../utils/axios';

const FeatureFlags = () => {
  const [flags, setFlags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeatureFlags = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axiosInstance.get('/feature-flags');
        
        if (response.data.success) {
          setFlags(response.data.data);
        } else {
          setError('Failed to fetch feature flags.');
        }
      } catch (err) {
        console.error('Error fetching feature flags:', err);
        setError('An error occurred while fetching feature flags.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchFeatureFlags();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Wrapper>
      <div className="container-fluid py-3">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="mb-0">Feature Flags</h2>
        </div>

        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        {isLoading && !error ? (
          <div className="d-flex justify-content-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="card shadow-sm">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="ps-4 py-3">Flag Name</th>
                      <th className="py-3">Description</th>
                      <th className="py-3">Status</th>
                      <th className="py-3">Creator</th>
                      <th className="text-end pe-4 py-3">Last Updated</th>
                    </tr>
                  </thead>
                  <tbody>
                    {flags.length > 0 ? (
                      flags.map((flag) => (
                        <tr key={flag.id}>
                          <td className="ps-4 fw-bold font-monospace text-dark">
                            {flag.flag_name}
                          </td>
                          <td className="text-muted">
                            {flag.description || <span className="fst-italic text-black-50">No description provided</span>}
                          </td>
                          <td>
                            {flag.flag_value ? (
                              <span className="badge bg-success px-2 py-1">Enabled</span>
                            ) : (
                              <span className="badge bg-secondary px-2 py-1">Disabled</span>
                            )}
                          </td>
                          <td>
                            <span className="badge border border-secondary text-secondary bg-light">
                              {flag.creator || 'System'}
                            </span>
                          </td>
                          <td className="text-end pe-4 text-muted small">
                            {formatDate(flag.updated_at || flag.created_at)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center py-5 text-muted">
                          No feature flags found in the system.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default FeatureFlags;